export enum RibbonType {
  RECOMMENDED = 'Recommended',
  SPONSORED = 'Sponsored',
  NEW_FREELANCER = 'New Freelancer',
  HIGHLIGHTED = 'Highlighted',
  DYNAMIC = 'Dynamic',
}

export enum DynamicBidTags {
  MOST_REPUTABLE = 'Most Reputable',
  MOST_REVIEWS = 'Most Reviews',
  HIGHEST_RATED = 'Highest Rated',
  MOST_REPEAT_HIRES = 'Most Repeat Hires',
  IN_TIMEZONE = 'In Your Timezone',
  VERIFIED = 'Verified',
  ENGLISH_NATIVE = 'Best English Native',
  HANDPICKED = 'Handpicked by Freelancer',
  NONE = 'None',
}
